import { createRouter, createWebHistory } from "vue-router";
// import HomeView from "../views/Master.vue";

import TemplateCargo from "@/views/cargo/Template.vue";
import CargoIndex from "@/views/cargo/index.vue";
import CargoShow from "@/views/cargo/show.vue";
// import CallHistory from "@/views/cargo/callHistory.vue";

import Load from "@/views/Load.vue";


import Support from "@/views/Support.vue";
// import Locate from "@/views/Locate.vue";
import Faq from "@/views/faq.vue";
import Feedback from "@/views/Feedback.vue";
import FeedbackFollow from "@/views/FeedbackFollow.vue";
import Service from "@/views/Service.vue";
import MyCargos from "@/views/myCargo/index.vue";
import Profile from "@/views/profile/Index.vue";
import ProfileEdit from "@/views/profile/Edit.vue";

import Login from "@/views/authentication/login";
import Verify from "@/views/authentication/verify";
import Register from "@/views/authentication/register";

import TermConditions from "@/views/TermConditions";
import ReturnLoads from "@/views/cargo/components/ReturnLoads.vue";

import Locate from "@/views/Locate.vue";


const routes = [
  {
    path: "/",
    name: "cargoemplate",
    component: TemplateCargo,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "home",
        component: CargoIndex,
        meta: { requiresAuth: true },
      },
      {
        path: ":load",
        name: "cargoShow",
        component: CargoShow,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        path: "/returnLoads/:city",
        name: "returnLoads",
        component: ReturnLoads,
        props: true,
        meta: { requiresAuth: true },
      }
    ],
  },
  {
    path: "/support",
    name: "support",
    component: Support,
    meta: { requiresAuth: true },
  },
  {
    path: "/load",
    name: "load",
    component: Load,
    meta: { requiresAuth: true },
  },
  {
    path: "/locate",
    name: "locate",
    component: Locate,
    meta: { requiresAuth: true },
  },
  {
    path: "/faq",
    name: "faq",
    component: Faq,
    meta: { requiresAuth: true },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: Feedback,
    meta: { requiresAuth: true },
  },
  {
    path: "/feedbackFollow",
    name: "feedbackFollow",
    component: FeedbackFollow,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/profileEdit",
    name: "profileEdit",
    component: ProfileEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/services",
    name: "service",
    component: Service,
    meta: { requiresAuth: true },
  },
  {
    path: "/myCargos",
    name: "myCargos",
    component: MyCargos,
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/callHistory",
  //   name: "callHistory",
  //   component: CallHistory,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/verify/:mobileNumber",
    name: "verify",
    component: Verify,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: "/register/:mobileNumber",
    name: "register",
    component: Register,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: "/terms-and-conditions",
    name: "term",
    component: TermConditions,
    // meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !localStorage.getItem("idUser")) {
    return { name: "login" };
  }
  if (to.meta.requiresAuth == false && localStorage.getItem("idUser")) {
    return { name: "home" };
  }
});

export default router;
